(function () {
  'use strict';

  angular
    .module('edistradadhluiApp')
    .factory('VersionCheck', VersionCheck);

  VersionCheck.$inject = ['$http', '$window', '$q', 'VERSION'];

  function VersionCheck($http, $window, $q, VERSION) {

    var reloadedKey = 'version_reloaded_from_' + VERSION;
    var LAST_CHECK_TS_KEY = 'version_last_check_ts';
    var MIN_INTERVAL_MS = 30 * 1000;

    function shouldSkipCheck() {
      try {
        var last = parseInt($window.sessionStorage.getItem(LAST_CHECK_TS_KEY) || '0', 10);
        return (Date.now() - last) < MIN_INTERVAL_MS;
      } catch (e) {
        return false;
      }
    }

    function markCheckedNow() {
      try {
        $window.sessionStorage.setItem(LAST_CHECK_TS_KEY, String(Date.now()));
      } catch (e) {}
    }

    function safeReloadOnce() {
      try {
        if ($window.sessionStorage.getItem(reloadedKey) === '1') return;
        $window.sessionStorage.setItem(reloadedKey, '1');
      } catch (e) {}
      $window.location.reload(true);
    }

    function checkAndReloadIfNeeded() {
      if (shouldSkipCheck()) {
        return $q.resolve();
      }
      markCheckedNow();

      return $http.get('version.json', {
        cache: false,
        params: { t: Date.now() }
      }).then(function (resp) {
        var serverVersion = resp && resp.data && resp.data.version ? String(resp.data.version) : null;
        if (!serverVersion) return;

        if (serverVersion !== String(VERSION)) {
          safeReloadOnce();
        }
      }).catch(function () {
      });
    }

    return {
      checkAndReloadIfNeeded: checkAndReloadIfNeeded
    };
  }
})();
